import { useSyncExternalStore } from "react";
import {
  getConsent,
  subscribe,
  type ConsentCategory,
  type ConsentState,
} from "../lib/consent";

/** The visitor's recorded consent, or `null` if they have not chosen yet. */
export function useConsent(): {
  consent: ConsentState | null;
  decided: boolean;
  analytics: boolean;
  marketing: boolean;
} {
  const consent = useSyncExternalStore(subscribe, getConsent, () => null);

  return {
    consent,
    decided: consent !== null,
    analytics: consent?.analytics === true,
    marketing: consent?.marketing === true,
  };
}

/** Convenience for gating a single category, e.g. the email opt-in checkbox. */
export function useConsentAllowed(category: ConsentCategory): boolean {
  const { consent } = useConsent();
  return consent?.[category] === true;
}
